:host {
  --hidden-display: none;
  --font-family: var(--ff-primary, 'Inter'), serif;
  --font-size: var(--fs-400, 16px);
  --line-height: var(--lh-300, 1.2);
  --font-weight: var(--fw-900, 700);
  --color: var(--neutral-grey-primary, #282828);
  --distance-items: .25rem;

  display: block;

  h5 {
    font-family: var(--font-family);
    font-size: var(--font-size);
    line-height: var(--line-height);
    font-weight: var(--font-weight);
    color: var(--color);
    margin: 0 0 var(--distance-items, .25rem);
  }

  slot {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
  }

  ::slotted(.item) {
    max-height: 500px;
    transition: all 0.3s ease-in-out;
    margin-top: var(--distance-items, .25rem);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: .25rem;
  }

  ::slotted(.hidden) {
    max-height: 0;
    overflow: hidden;
  }
}


